export default __webpack_public_path__ + "static/source-separation-systems-circular-economy-35e78e34ae1c7641904a05e8b6badcde.svg";